import { AlarmLevel } from "../models/metMap/forecastResult";
import { ColorScale, ColorStyling } from "./colorStyling";
export default class FontAwesomeStyling {
    static icon(fullFaClass, color) {
        return `<i class='${fullFaClass}' style='color:${color}'></i>`;
    }
    static iconAndText(fullFaClass, color, text) {
        return `<span class='text-icon'>${FontAwesomeStyling.icon(fullFaClass, color)}</span> ${text}`;
    }
    static alarmIconAndText(alarmLevel, text) {
        if (alarmLevel < AlarmLevel.Warning)
            return text;
        return `<span class='text-icon'>${FontAwesomeStyling.alarmIcon(alarmLevel)}</span> ${text}`;
    }
    static alarmIcon(alarmLevel) {
        if (alarmLevel < AlarmLevel.Warning)
            return "";
        const color = ColorStyling.alarmColor(alarmLevel, ColorScale.Loud).toString();
        const faClass = alarmLevel === AlarmLevel.AboveMax ?
            'fa fa-exclamation-circle' :
            alarmLevel === AlarmLevel.Alarm ?
                'fa fa-exclamation-circle' :
                alarmLevel === AlarmLevel.Warning ?
                    'fa fa-exclamation-triangle' : '';
        return `<i class='${faClass}' style='color:${color}'></i>`;
    }
    static class(alarmLevel) {
        return alarmLevel === AlarmLevel.AboveMax ?
            "fa fa-exclamation-circle" :
            alarmLevel === AlarmLevel.Alarm ?
                "fa fa-exclamation-circle" :
                alarmLevel === AlarmLevel.Warning ?
                    "fa fa-exclamation-triangle" :
                    alarmLevel === AlarmLevel.OK ?
                        "fa fa-check" :
                        "";
    }
    static char(alarmLevel) {
        return alarmLevel === AlarmLevel.AboveMax ?
            "\uf06a" :
            alarmLevel === AlarmLevel.Alarm ?
                "\uf06a" :
                alarmLevel === AlarmLevel.Warning ?
                    "\uf071" :
                    alarmLevel === AlarmLevel.OK ?
                        "" :
                        "";
    }
}
